export default __webpack_public_path__ + "8b5029f1aefc52003257827cc55d556b.svg";